import { PRODUCT_ATTRIBUTES } from '~/constants/products';
import type { ProductVariant } from '~/utils/ct/types/product/ProductVariant';

export function getProductGTIN(product: ProductVariant): string {
  const eanAttribute = product?.attributesRaw?.find(
    (attr) => attr.name === PRODUCT_ATTRIBUTES.EUROPEAN_ARTICLE_NUMBER,
  )?.value;
  return eanAttribute;
}
